export const FormatsData: import('../sim/dex-species').SpeciesFormatsDataTable = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	venusaurmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	venusaurgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	charizardmegax: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	charizardmegay: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	charizardgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	blastoisemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	blastoisegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	caterpie: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	metapod: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	butterfree: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	butterfreegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	weedle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kakuna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	beedrill: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	beedrillmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pidgey: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pidgeotto: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	pidgeot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pidgeotmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rattata: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	rattataalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	raticate: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	raticatealola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	raticatealolatotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	spearow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	fearow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pichu: {
		tier: "LC",
	},
	pichuspikyeared: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachu: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachucosplay: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachurockstar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachubelle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachupopstar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuphd: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachulibre: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuoriginal: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachuhoenn: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachusinnoh: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachuunova: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachukalos: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachualola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachupartner: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachustarter: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	pikachugmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuworld: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	raichu: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	raichualola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	raichumegax: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	raichumegay: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sandshrew: {
		tier: "LC",
	},
	sandshrewalola: {
		tier: "LC",
	},
	sandslash: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandslashalola: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nidoranf: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	nidorina: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	nidoqueen: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	nidoranm: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	nidorino: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	nidoking: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
		doublesTier: "DUU",
		natDexTier: "NFE",
	},
	clefable: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	clefablemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	vulpix: {
		tier: "NFE",
		doublesTier: "NFE",
		natDexTier: "LC",
	},
	vulpixalola: {
		tier: "NFE",
	},
	ninetales: {
		tier: "ZU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	ninetalesalola: {
		tier: "PU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zubat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	golbat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	crobat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bellossom: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	paras: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	parasect: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	diglett: {
		tier: "NFE",
	},
	diglettalola: {
		tier: "LC",
	},
	dugtrio: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dugtrioalola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	meowth: {
		tier: "LC",
	},
	meowthalola: {
		tier: "LC",
	},
	meowthgalar: {
		tier: "LC",
	},
	meowthgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	persian: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	persianalola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	perrserker: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "NFE",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	growlithe: {
		tier: "LC",
	},
	growlithehisui: {
		tier: "LC",
	},
	arcanine: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	arcaninehisui: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	politoed: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	abra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kadabra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	alakazam: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	alakazammega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	machop: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	machoke: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	machamp: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	machampgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	victreebelmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	geodude: {
		tier: "LC",
	},
	geodudealola: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	graveleralola: {
		tier: "NFE",
	},
	golem: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	golemalola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ponyta: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ponytagalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	rapidash: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rapidashgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowpokegalar: {
		tier: "LC",
	},
	slowbro: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	slowbromega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	slowbrogalar: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	slowking: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	slowkinggalar: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "ZU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	magnezone: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	farfetchd: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	farfetchdgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sirfetchd: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	grimer: {
		tier: "LC",
	},
	grimeralola: {
		tier: "LC",
	},
	muk: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mukalola: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shellder: {
		tier: "NFE",
	},
	cloyster: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gastly: {
		tier: "NFE",
	},
	haunter: {
		tier: "NFE",
	},
	gengar: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	gengarmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "AG",
	},
	gengargmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	onix: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	steelix: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	steelixmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	krabby: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kingler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kinglergmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	voltorb: {
		tier: "LC",
	},
	voltorbhisui: {
		tier: "NFE",
		doublesTier: "LC",
		natDexTier: "LC",
	},
	electrode: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	electrodehisui: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	exeggutoralola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cubone: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	marowak: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	marowakalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	marowakalolatotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hitmonchan: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hitmontop: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lickitung: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lickilicky: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	weezinggalar: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "PU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	rhyperior: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "NU",
		doublesTier: "NFE",
		natDexTier: "UU",
	},
	blissey: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	tangela: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	tangrowth: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kangaskhan: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kangaskhanmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		tier: "ZUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	goldeen: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	seaking: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	staryu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	starmie: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	starmiemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	mimejr: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mrmime: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mrmimegalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	mrrime: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	scyther: {
		tier: "NU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	scizor: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	scizormega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	kleavor: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	smoochum: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	jynx: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NFE",
	},
	electivire: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	magby: {
		tier: "NFE",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pinsir: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pinsirmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	tauros: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	taurospaldeacombat: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	taurospaldeablaze: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	taurospaldeaaqua: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	gyaradosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	lapras: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	laprasgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ditto: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	eevee: {
		tier: "LC",
	},
	eeveestarter: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	eeveegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vaporeon: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	jolteon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flareon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	espeon: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	umbreon: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	leafeon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	glaceon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sylveon: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	porygon: {
		tier: "NFE",
	},
	porygon2: {
		tier: "PU",
		doublesTier: "DUU",
		natDexTier: "NFE",
	},
	porygonz: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	omanyte: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	omastar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kabuto: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kabutops: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	aerodactyl: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	aerodactylmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	snorlaxgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	articuno: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	articunogalar: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zapdos: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	zapdosgalar: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	moltres: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	moltresgalar: {
		tier: "UUBL",
		doublesTier: "DOU",
		natDexTier: "RUBL",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	dragonitemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	mewtwomegax: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mewtwomegay: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mew: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	meganiummega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	typhlosionhisui: {
		tier: "PU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	feraligatrmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ledyba: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ledian: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	togepi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	togetic: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	togekiss: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	natu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	xatu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ampharosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	aipom: {
		tier: "NFE",
	},
	ambipom: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	yanma: {
		tier: "NFE",
	},
	yanmega: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wooper: {
		tier: "LC",
	},
	wooperpaldea: {
		tier: "LC",
	},
	quagsire: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	murkrow: {
		tier: "NFE",
		doublesTier: "DUU",
	},
	honchkrow: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	misdreavus: {
		tier: "NFE",
	},
	mismagius: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	unown: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wynaut: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	wobbuffet: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	girafarig: {
		tier: "NFE",
	},
	farigiraf: {
		tier: "ZU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dunsparce: {
		tier: "NFE",
	},
	dudunsparce: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gligar: {
		tier: "NU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	gliscor: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	qwilfish: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	qwilfishhisui: {
		tier: "PU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	overqwil: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shuckle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	heracross: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	heracrossmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	sneasel: {
		tier: "ZU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	sneaselhisui: {
		tier: "ZU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	weavile: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	sneasler: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "NFE",
	},
	ursaluna: {
		tier: "UUBL",
		doublesTier: "DOU",
		natDexTier: "RUBL",
	},
	ursalunabloodmoon: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NFE",
	},
	mamoswine: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	corsola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	corsolagalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	cursola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	remoraid: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	octillery: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	delibird: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mantyke: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mantine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	skarmory: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	skarmorymega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	houndoommega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	stantler: {
		tier: "NFE",
	},
	wyrdeer: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	smeargle: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	miltank: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	raikou: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	entei: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	suicune: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	tyranitarmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	lugia: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	hooh: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	celebi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sceptilemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	torchic: {
		tier: "NFE",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	blazikenmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	swampertmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zigzagoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	zigzagoongalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	linoone: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	linoonegalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	obstagoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wurmple: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	silcoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	beautifly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cascoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	dustox: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	taillow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swellow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gardevoirmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	gallade: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	gallademega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "NFE",
	},
	slaking: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nincada: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ninjask: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shedinja: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	whismur: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	loudred: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	exploud: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	skitty: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	delcatty: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sableye: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sableyemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	mawile: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mawilemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	aron: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lairon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	aggron: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	aggronmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	medichammega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	electrike: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	manectric: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	manectricmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	plusle: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	minun: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	volbeat: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	illumise: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	budew: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	roselia: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	roserade: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	carvanha: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sharpedo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sharpedomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	wailmer: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	wailord: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cameruptmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	torkoal: {
		tier: "ZU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	spinda: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	altariamega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	zangoose: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	seviper: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lunatone: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	solrock: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	baltoy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	claydol: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lileep: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cradily: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	anorith: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	armaldo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	castform: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	castformsunny: {
		isNonstandard: "Past",
	},
	castformrainy: {
		isNonstandard: "Past",
	},
	castformsnowy: {
		isNonstandard: "Past",
	},
	kecleon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	banettemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NFE",
	},
	dusknoir: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tropius: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chimechomega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	absol: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	absolmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	absolmegaz: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	glaliemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	froslass: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	froslassmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	spheal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sealeo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	walrein: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	clamperl: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	huntail: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gorebyss: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	relicanth: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	luvdisc: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	salamencemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NFE",
	},
	metagross: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	metagrossmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	regirock: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	regice: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	registeel: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	latias: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	latiasmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	latios: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	latiosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	kyogre: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	kyogreprimal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	groudon: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	groudonprimal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	rayquaza: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	rayquazamega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "AG",
	},
	jirachi: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	deoxys: {
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	deoxysattack: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	deoxysdefense: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	deoxysspeed: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "NFE",
	},
	infernape: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "NFE",
	},
	empoleon: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	staraptormega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	bidoof: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bibarel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	burmy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	wormadam: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wormadamsandy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wormadamtrash: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mothim: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pachirisu: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cherubi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cherrim: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cherrimsunshine: {
		isNonstandard: "Past",
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	drifloon: {
		tier: "LC",
		natDexTier: "NFE",
	},
	drifblim: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	buneary: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lopunny: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lopunnymega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	glameow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	purugly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chatot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spiritomb: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "NFE",
	},
	garchomp: {
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	garchompmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "(OU)",
	},
	garchompmegaz: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lucariomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	lucariomegaz: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	skorupi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	drapion: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	carnivine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		tier: "ZU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	abomasnowmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rotom: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotomheat: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotomwash: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	rotomfrost: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotomfan: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotommow: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	uxie: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mesprit: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	azelf: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dialga: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	dialgaorigin: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	palkia: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	palkiaorigin: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	heatran: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	heatranmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	regigigas: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	giratina: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	giratinaorigin: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	cresselia: {
		tier: "NUBL",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	phione: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	manaphy: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	darkrai: {
		tier: "OU",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	darkraimega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	shaymin: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shayminsky: {
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	arceus: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	victini: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	snivy: {
		tier: "NFE",
	},
	servine: {
		tier: "NFE",
	},
	serperior: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	tepig: {
		tier: "LC",
	},
	pignite: {
		tier: "NFE",
	},
	emboar: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	emboarmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	oshawott: {
		tier: "LC",
	},
	dewott: {
		tier: "NFE",
	},
	samurott: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	samurotthisui: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	patrat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	watchog: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lillipup: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	herdier: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	stoutland: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	purrloin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	liepard: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pansage: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simisage: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pansear: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simisear: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	panpour: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simipour: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	munna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	musharna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pidove: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	tranquill: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	unfezant: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	blitzle: {
		tier: "LC",
	},
	zebstrika: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	roggenrola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	boldore: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	gigalith: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	woobat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	swoobat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	drilbur: {
		tier: "LC",
	},
	excadrill: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	excadrillmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	audino: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	audinomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	timburr: {
		tier: "LC",
	},
	gurdurr: {
		tier: "ZU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	conkeldurr: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	tympole: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	palpitoad: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	seismitoad: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	throh: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sawk: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sewaddle: {
		tier: "LC",
	},
	swadloon: {
		tier: "NFE",
	},
	leavanny: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	venipede: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	whirlipede: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	scolipede: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	scolipedemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	cottonee: {
		tier: "LC",
	},
	whimsicott: {
		tier: "ZU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	petilil: {
		tier: "LC",
	},
	lilligant: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lilliganthisui: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	basculin: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	basculegion: {
		tier: "NU",
		doublesTier: "DUber",
		natDexTier: "RU",
	},
	basculegionf: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	sandile: {
		tier: "LC",
	},
	krokorok: {
		tier: "NFE",
	},
	krookodile: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	darumaka: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	darumakagalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	darmanitan: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	darmanitanzen: {
		isNonstandard: "Past",
	},
	darmanitangalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	darmanitangalarzen: {
		isNonstandard: "Past",
	},
	maractus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	dwebble: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	crustle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	scraggy: {
		tier: "NFE",
	},
	scrafty: {
		tier: "PUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	scraftymega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sigilyph: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	yamask: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	yamaskgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cofagrigus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	runerigus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tirtouga: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	carracosta: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	archen: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	archeops: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	trubbish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	garbodor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	garbodorgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zorua: {
		tier: "LC",
	},
	zoruahisui: {
		tier: "LC",
	},
	zoroark: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zoroarkhisui: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	minccino: {
		tier: "LC",
	},
	cinccino: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gothita: {
		tier: "LC",
	},
	gothorita: {
		tier: "NFE",
	},
	gothitelle: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	solosis: {
		tier: "LC",
	},
	duosion: {
		tier: "NFE",
	},
	reuniclus: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ducklett: {
		tier: "LC",
	},
	swanna: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	vanillite: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	vanillish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	vanilluxe: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	deerling: {
		tier: "LC",
	},
	sawsbuck: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	emolga: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	karrablast: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	escavalier: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	foongus: {
		tier: "LC",
	},
	amoonguss: {
		tier: "PU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	frillish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	jellicent: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	alomomola: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	joltik: {
		tier: "LC",
	},
	galvantula: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ferroseed: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ferrothorn: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	klink: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	klang: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	klinklang: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tynamo: {
		tier: "LC",
	},
	eelektrik: {
		tier: "NFE",
	},
	eelektross: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	eelektrossmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	elgyem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	beheeyem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	litwick: {
		tier: "LC",
	},
	lampent: {
		tier: "NFE",
	},
	chandelure: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chandeluremega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	axew: {
		tier: "LC",
	},
	fraxure: {
		tier: "NFE",
	},
	haxorus: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	cubchoo: {
		tier: "LC",
	},
	beartic: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cryogonal: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shelmet: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	accelgor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stunfisk: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stunfiskgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mienfoo: {
		tier: "LC",
	},
	mienshao: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	druddigon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	golett: {
		tier: "LC",
	},
	golurk: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	golurkmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	pawniard: {
		tier: "LC",
	},
	bisharp: {
		tier: "RU",
		doublesTier: "NFE",
		natDexTier: "UU",
	},
	bouffalant: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rufflet: {
		tier: "NFE",
	},
	braviary: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	braviaryhisui: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	vullaby: {
		tier: "LC",
	},
	mandibuzz: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	heatmor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	durant: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	deino: {
		tier: "LC",
	},
	zweilous: {
		tier: "NFE",
	},
	hydreigon: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	larvesta: {
		tier: "LC",
	},
	volcarona: {
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	cobalion: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	terrakion: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	virizion: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tornadus: {
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	tornadustherian: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	thundurus: {
		tier: "RUBL",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	thundurustherian: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	reshiram: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zekrom: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	landorus: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	landorustherian: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	kyurem: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	kyuremblack: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	kyuremwhite: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	keldeo: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	meloetta: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	genesect: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	genesectburn: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	genesectchill: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	genesectdouse: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	genesectshock: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	chespin: {
		tier: "LC",
	},
	quilladin: {
		tier: "NFE",
	},
	chesnaught: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chesnaughtmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	fennekin: {
		tier: "LC",
	},
	braixen: {
		tier: "NFE",
	},
	delphox: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	delphoxmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	froakie: {
		tier: "LC",
	},
	frogadier: {
		tier: "NFE",
	},
	greninja: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	greninjaash: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	greninjamega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	bunnelby: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	diggersby: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	fletchling: {
		tier: "LC",
	},
	fletchinder: {
		tier: "NFE",
	},
	talonflame: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	scatterbug: {
		tier: "LC",
	},
	spewpa: {
		tier: "NFE",
	},
	vivillon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	litleo: {
		tier: "LC",
	},
	pyroar: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pyroarmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	flabebe: {
		tier: "LC",
	},
	floette: {
		tier: "NFE",
	},
	floetteeternal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	floettemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	florges: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	skiddo: {
		tier: "LC",
	},
	gogoat: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pancham: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pangoro: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	furfrou: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	espurr: {
		tier: "LC",
	},
	meowstic: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	meowsticmmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	meowsticfmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	honedge: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	doublade: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	aegislash: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	aegislashblade: {
		isNonstandard: "Past",
	},
	spritzee: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	aromatisse: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	swirlix: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	slurpuff: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	inkay: {
		tier: "LC",
	},
	malamar: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	malamarmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	binacle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	barbaracle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	barbaraclemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	skrelp: {
		tier: "LC",
	},
	dragalge: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dragalgemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	clauncher: {
		tier: "LC",
	},
	clawitzer: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	helioptile: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	heliolisk: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tyrunt: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	tyrantrum: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	amaura: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	aurorus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	hawlucha: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	hawluchamega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	dedenne: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	carbink: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	goomy: {
		tier: "LC",
	},
	sliggoo: {
		tier: "NFE",
	},
	sliggoohisui: {
		tier: "NFE",
	},
	goodra: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	goodrahisui: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	klefki: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	phantump: {
		tier: "LC",
	},
	trevenant: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pumpkaboo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pumpkaboosmall: {
		isNonstandard: "Past",
	},
	pumpkaboolarge: {
		isNonstandard: "Past",
	},
	pumpkaboosuper: {
		isNonstandard: "Past",
	},
	gourgeist: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gourgeistsmall: {
		isNonstandard: "Past",
	},
	gourgeistlarge: {
		isNonstandard: "Past",
	},
	gourgeistsuper: {
		isNonstandard: "Past",
	},
	bergmite: {
		tier: "LC",
	},
	avalugg: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	avalugghisui: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	noibat: {
		tier: "LC",
	},
	noivern: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	xerneas: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "AG",
	},
	xerneasneutral: {
		isNonstandard: "Custom", // can't be used in battle
		tier: "Illegal",
	},
	yveltal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	zygarde: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	zygarde10: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	zygardecomplete: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	zygardemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	diancie: {
		tier: "RU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	dianciemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	hoopa: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hoopaunbound: {
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "UUBL",
	},
	volcanion: {
		tier: "RUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	rowlet: {
		tier: "LC",
	},
	dartrix: {
		tier: "NFE",
	},
	decidueye: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	decidueyehisui: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	litten: {
		tier: "LC",
	},
	torracat: {
		tier: "NFE",
	},
	incineroar: {
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	popplio: {
		tier: "LC",
	},
	brionne: {
		tier: "NFE",
	},
	primarina: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "RUBL",
	},
	pikipek: {
		tier: "LC",
	},
	trumbeak: {
		tier: "NFE",
	},
	toucannon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	yungoos: {
		tier: "LC",
	},
	gumshoos: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gumshoostotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grubbin: {
		tier: "LC",
	},
	charjabug: {
		tier: "NFE",
	},
	vikavolt: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	vikavolttotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	crabrawler: {
		tier: "LC",
	},
	crabominable: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	crabominablemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	oricorio: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oricoriopompom: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oricoriopau: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oricoriosensu: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cutiefly: {
		tier: "NFE",
	},
	ribombee: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ribombeetotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rockruff: {
		tier: "LC",
	},
	rockruffdusk: {
		tier: "LC",
	},
	lycanroc: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lycanrocmidnight: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lycanrocdusk: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wishiwashi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wishiwashischool: {
		isNonstandard: "Past",
	},
	mareanie: {
		tier: "LC",
	},
	toxapex: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	mudbray: {
		tier: "LC",
	},
	mudsdale: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dewpider: {
		tier: "LC",
	},
	araquanid: {
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	araquanidtotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	fomantis: {
		tier: "LC",
	},
	lurantis: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lurantistotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	morelull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	shiinotic: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	salandit: {
		tier: "LC",
	},
	salazzle: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	salazzletotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	stufful: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bewear: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	bounsweet: {
		tier: "LC",
	},
	steenee: {
		tier: "NFE",
	},
	tsareena: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	comfey: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	oranguru: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	passimian: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wimpod: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	golisopod: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	golisopodmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sandygast: {
		tier: "LC",
	},
	palossand: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pyukumuku: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	typenull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	silvally: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallybug: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallydark: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallydragon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyelectric: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyfairy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyfighting: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyfire: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyflying: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyghost: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallygrass: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyground: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyice: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallypoison: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallypsychic: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyrock: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallysteel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallywater: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	minior: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	komala: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	turtonator: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	togedemaru: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	togedemarutotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mimikyu: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mimikyutotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mimikyubustedtotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bruxish: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	drampa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	drampamega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	dhelmise: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	jangmoo: {
		tier: "LC",
	},
	hakamoo: {
		tier: "NFE",
	},
	kommoo: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	kommoototem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tapukoko: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	tapulele: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	tapubulu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tapufini: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	cosmog: {
		tier: "LC",
	},
	cosmoem: {
		tier: "NFE",
	},
	solgaleo: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	lunala: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	nihilego: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	buzzwole: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	pheromosa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	xurkitree: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	celesteela: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	kartana: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	guzzlord: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	necrozma: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	necrozmaduskmane: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	necrozmadawnwings: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	necrozmaultra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	magearna: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	magearnamega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	magearnaoriginalmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	marshadow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	poipole: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	naganadel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	stakataka: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	blacephalon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	zeraora: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	zeraoramega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	meltan: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	melmetal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	melmetalgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grookey: {
		tier: "LC",
	},
	thwackey: {
		tier: "NU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	rillaboom: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	rillaboomgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	scorbunny: {
		tier: "LC",
	},
	raboot: {
		tier: "NFE",
	},
	cinderace: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	cinderacegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sobble: {
		tier: "LC",
	},
	drizzile: {
		tier: "NFE",
	},
	inteleon: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	inteleongmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	skwovet: {
		tier: "LC",
	},
	greedent: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rookidee: {
		tier: "LC",
	},
	corvisquire: {
		tier: "NFE",
	},
	corviknight: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	corviknightgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	blipbug: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dottler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	orbeetle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	orbeetlegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nickit: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	thievul: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gossifleur: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	eldegoss: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wooloo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dubwool: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	chewtle: {
		tier: "LC",
	},
	drednaw: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	drednawgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	yamper: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	boltund: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rolycoly: {
		tier: "LC",
	},
	carkol: {
		tier: "NFE",
	},
	coalossal: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	coalossalgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	applin: {
		tier: "LC",
	},
	flapple: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flapplegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	appletun: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	appletungmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dipplin: {
		tier: "NFE",
	},
	silicobra: {
		tier: "LC",
	},
	sandaconda: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandacondagmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cramorant: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	arrokuda: {
		tier: "LC",
	},
	barraskewda: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxel: {
		tier: "LC",
	},
	toxtricity: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxtricitygmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	toxtricitylowkeygmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sizzlipede: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	centiskorch: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	centiskorchgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	clobbopus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	grapploct: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sinistea: {
		tier: "LC",
	},
	polteageist: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	hatenna: {
		tier: "LC",
	},
	hattrem: {
		tier: "NFE",
	},
	hatterene: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	hatterenegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	impidimp: {
		tier: "LC",
	},
	morgrem: {
		tier: "NFE",
	},
	grimmsnarl: {
		tier: "PU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	grimmsnarlgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	milcery: {
		tier: "LC",
	},
	alcremie: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	alcremiegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	falinks: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	falinksmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	pincurchin: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	snom: {
		tier: "LC",
	},
	frosmoth: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	stonjourner: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	eiscue: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	indeedee: {
		tier: "PUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	indeedeef: {
		tier: "ZU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	morpeko: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cufant: {
		tier: "LC",
	},
	copperajah: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	copperajahgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dracozolt: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	arctozolt: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	dracovish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	arctovish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	duraludon: {
		tier: "NU",
		doublesTier: "NFE",
		natDexTier: "RU",
	},
	duraludongmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dreepy: {
		tier: "LC",
	},
	drakloak: {
		tier: "NFE",
	},
	dragapult: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "Uber",
	},
	zacian: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zaciancrowned: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zamazenta: {
		tier: "OU",
		doublesTier: "DUber",
		natDexTier: "OU",
	},
	zamazentacrowned: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	eternatus: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	eternatuseternamax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kubfu: {
		tier: "NFE",
	},
	urshifu: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	urshifurapidstrike: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "OU",
	},
	urshifugmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	urshifurapidstrikegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zarude: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	regieleki: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	regidrago: {
		tier: "NUBL",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	glastrier: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	spectrier: {
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	calyrex: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	calyrexice: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	calyrexshadow: {
		tier: "AG",
		doublesTier: "DUber",
		natDexTier: "AG",
	},
	enamorus: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "RUBL",
	},
	enamorustherian: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sprigatito: {
		tier: "LC",
	},
	floragato: {
		tier: "NFE",
	},
	meowscarada: {
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "UUBL",
	},
	fuecoco: {
		tier: "LC",
	},
	crocalor: {
		tier: "NFE",
	},
	skeledirge: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	quaxly: {
		tier: "LC",
	},
	quaxwell: {
		tier: "NFE",
	},
	quaquaval: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	lechonk: {
		tier: "LC",
	},
	oinkologne: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oinkolognef: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tarountula: {
		tier: "LC",
	},
	spidops: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nymble: {
		tier: "LC",
	},
	lokix: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rellor: {
		tier: "LC",
	},
	rabsca: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	greavard: {
		tier: "LC",
	},
	houndstone: {
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	flittle: {
		tier: "NFE",
	},
	espathra: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	wiglett: {
		tier: "LC",
	},
	wugtrio: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dondozo: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	veluza: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	finizen: {
		tier: "LC",
	},
	palafin: {
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	smoliv: {
		tier: "LC",
	},
	dolliv: {
		tier: "NFE",
	},
	arboliva: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	capsakid: {
		tier: "LC",
	},
	scovillain: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	scovillainmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	tadbulb: {
		tier: "LC",
	},
	bellibolt: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	varoom: {
		tier: "LC",
	},
	revavroom: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	orthworm: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tandemaus: {
		tier: "LC",
	},
	maushold: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	cetoddle: {
		tier: "LC",
	},
	cetitan: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	frigibax: {
		tier: "LC",
	},
	arctibax: {
		tier: "NFE",
	},
	baxcalibur: {
		tier: "Uber",
		doublesTier: "DUU",
		natDexTier: "Uber",
	},
	baxcaliburmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	tatsugiri: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tatsugiricurlymega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	tatsugiridroopymega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	tatsugiristretchymega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	cyclizar: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pawmi: {
		tier: "LC",
	},
	pawmo: {
		tier: "NFE",
	},
	pawmot: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wattrel: {
		tier: "LC",
	},
	kilowattrel: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bombirdier: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	squawkabilly: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flamigo: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	klawf: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nacli: {
		tier: "LC",
	},
	naclstack: {
		tier: "NFE",
	},
	garganacl: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	glimmet: {
		tier: "LC",
	},
	glimmora: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	glimmoramega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	shroodle: {
		tier: "LC",
	},
	grafaiai: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	fidough: {
		tier: "LC",
	},
	dachsbun: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	maschiff: {
		tier: "LC",
	},
	mabosstiff: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bramblin: {
		tier: "LC",
	},
	brambleghast: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gimmighoul: {
		tier: "LC",
	},
	gimmighoulroaming: {
		tier: "LC",
	},
	gholdengo: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	greattusk: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	brutebonnet: {
		tier: "ZU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	sandyshocks: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	screamtail: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	fluttermane: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	slitherwing: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	roaringmoon: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	irontreads: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	ironmoth: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	ironhands: {
		tier: "UUBL",
		doublesTier: "DOU",
		natDexTier: "UUBL",
	},
	ironjugulis: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ironthorns: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ironbundle: {
		tier: "Uber",
		doublesTier: "DUU",
		natDexTier: "Uber",
	},
	ironvaliant: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	tinglu: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	chienpao: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	wochien: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chiyu: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	koraidon: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "AG",
	},
	miraidon: {
		tier: "AG",
		doublesTier: "DUber",
		natDexTier: "AG",
	},
	tinkatink: {
		tier: "LC",
	},
	tinkatuff: {
		tier: "NFE",
	},
	tinkaton: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	charcadet: {
		tier: "LC",
	},
	armarouge: {
		tier: "RUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	ceruledge: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	toedscool: {
		tier: "LC",
	},
	toedscruel: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	kingambit: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	clodsire: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	annihilape: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	walkingwake: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	ironleaves: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	poltchageist: {
		tier: "LC",
	},
	sinistcha: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	okidogi: {
		tier: "UUBL",
		doublesTier: "DOU",
		natDexTier: "UUBL",
	},
	munkidori: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	fezandipiti: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ogerpon: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ogerponwellspring: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	ogerponhearthflame: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	ogerponcornerstone: {
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "UUBL",
	},
	archaludon: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "RUBL",
	},
	hydrapple: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	gougingfire: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	ragingbolt: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	ironboulder: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	ironcrown: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "UUBL",
	},
	terapagos: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "OU",
	},
	terapagosstellar: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	pecharunt: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	missingno: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	syclar: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	syclant: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	revenankh: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	embirch: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	flarelm: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	pyroak: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	breezi: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	fidgit: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	rebble: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	tactite: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	stratagem: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	privatyke: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	arghonaut: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	nohface: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	kitsunoh: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	monohm: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	duohm: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	cyclohm: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	dorsoil: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	colossoil: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	protowatt: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	krilowatt: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	voodoll: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	voodoom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	scratchet: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	tomohawk: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	necturine: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	necturna: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	mollux: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	cupra: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	argalis: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	aurumoth: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	brattler: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	malaconda: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	cawdet: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	cawmodore: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	volkritter: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	volkraken: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	snugglow: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	plasmanta: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	floatoy: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	caimanoe: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	naviathan: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	crucibelle: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	crucibellemega: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pluffle: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	kerfluffle: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pajantom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	mumbao: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	jumbao: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	fawnifer: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	electrelk: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	caribolt: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	smogecko: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	smoguana: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	smokomodo: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	swirlpool: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	coribalis: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	snaelstrom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	justyke: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	equilibra: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	solotl: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	astrolotl: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	miasmite: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	miasmaw: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	chromera: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	venomicon: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	venomiconepilogue: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	saharascal: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	saharaja: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	ababo: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	scattervein: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	hemogoblin: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	cresceidon: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	chuggon: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	draggalong: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	chuggalong: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	flox: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	shox: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	ramnarok: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	ramnarokradiant: {
		isNonstandard: "CAP",
		tier: "Illegal",
	},
	obliteryx: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pokestarsmeargle: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufo: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufo2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarbrycenman: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmt: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmt2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestartransport: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestargiant: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarhumanoid: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmonster: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarf00: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarf002: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarspirit: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarblackdoor: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarwhitedoor: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarblackbelt: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufopropu2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
};
